import React, { useState, useEffect } from 'react';
import ViewReturnGiftPage from './components/viewReturnGiftPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getReturnGiftsList } from './redux/slice';

function ViewReturnGift() {
  TabTitle('Gift Register - View Gift Returns');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    returnGiftsList,
    pagination,
    returnGiftsListLoading,
    CountsReturnGiftsList
  } = useSelector((state) => state.returnGifts);
  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [isSwitch, setIsSwitch] = useState(true);

  console.log('searchRequest', searchRequest);
  console.log(triggerFilter);
  console.log('returnGiftsList', returnGiftsList);

  useEffect(() => {
    handleGetPastGiftsList();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetPastGiftsList();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest, isSwitch]); //page,

  const handleGetPastGiftsList = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest,
      delegation_type: isSwitch === true ? 'self' : 'delegated'
    };
    dispatch(getReturnGiftsList(payload));
  };
  const onChange = () => {
    setTriggerFilter(true);
    setIsSwitch(!isSwitch);
  };
  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  }; */

  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <ViewReturnGiftPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          pastGiftsList={returnGiftsList}
          pagination={pagination}
          pastGiftsListLoading={returnGiftsListLoading}
          CountsReturnGiftsList={CountsReturnGiftsList}
          setSearchRequest={setSearchRequest}
          onChange={onChange}
        />
      </div>
    </CustomLayout>
  );
}
export default ViewReturnGift;
